import request from "./httpService";
const EMPLOYEE_ENDPOINT = '/employee';

const add = (data) => {
    return request({
        method: "POST",
        url: `${EMPLOYEE_ENDPOINT}/new`,
        data: data,
    });
};

const getPractitioners = () => {
    return request({
        method: "GET",
        url: `${EMPLOYEE_ENDPOINT}/practitioner`
    });
};

const getById = (id,signal) => {
    return request({
        method: "GET",
        url: `${EMPLOYEE_ENDPOINT}/${id}`,
        signal: signal
    });
}

const get = (signal) => {
    return request({
        method: "GET",
        url: `${EMPLOYEE_ENDPOINT}/`,
        signal: signal
    });
}

const getWithLimit = (from, to, filters, sortBy, signal) => {
    return request({
        method: "GET",
        url: `${EMPLOYEE_ENDPOINT}/withlimit/${from}/${to}`,
        params: {filters: filters, sortBy: sortBy},
        signal: signal
    });
}

const deleteEmployee = (rowids) => {
    return request({
        method: "DELETE",
        url: `${EMPLOYEE_ENDPOINT}`,
        params: {rowid: rowids}
    });
};

const update = (data) => {
    return request({
        method: "PUT",
        url: `${EMPLOYEE_ENDPOINT}/`,
        data: data,
    });
};

export const EmployeeService = {
    add,
    getById,
    get,
    getAll: get,
    getWithLimit,
    getPractitioners,
    deleteEmployee,
    update,
};